import {
  BaseEndpointBuilder,
  endpointBuilder,
} from '@squareup/dex-data-shared-base-api';
import { HTTP_METHOD } from '@squareup/dex-types-shared-http';
import {
  TestMerchant,
  CreateTestMerchantInput,
  GetTestMerchantsPayload,
  SeedDataSuite,
  GetSeedDataSuiteInput,
} from '@squareup/dex-types-shared-test-merchant';

import { DEVELOPER_API_REDUCER_PATH } from './developer-api-constants';
import { DeveloperApiTagTypes } from './developer-api-tag-types';

const TEST_MERCHANT_API_URL = '/api/test-merchants';

const testMerchantsEndpointsFactory = (
  builder: BaseEndpointBuilder<typeof DEVELOPER_API_REDUCER_PATH>
) => ({
  /**
   * Creates a new Test merchant.
   */
  createTestMerchant: builder.mutation<
    {
      test_merchant: TestMerchant;
      errors: unknown;
    },
    CreateTestMerchantInput
  >({
    query: (input) => {
      return {
        path: `${TEST_MERCHANT_API_URL}`,
        method: HTTP_METHOD.POST,
        additionalHeaders: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...input,
        }),
      };
    },
    invalidatesTags: [DeveloperApiTagTypes.TestMerchant],
  }),
  /**
   * Get seed data suites
   */
  getSeedDataSuites: builder.query<
    {
      suites: SeedDataSuite[];
      errors: unknown;
    },
    GetSeedDataSuiteInput
  >({
    query: ({ country, currency }: GetSeedDataSuiteInput) => {
      return {
        path: `${TEST_MERCHANT_API_URL}/seed-data-suites?country=${country}&currency=${currency}`,
      };
    },
  }),

  /**
   * Get all test merchants associated with the person.
   */
  getTestMerchants: builder.query<GetTestMerchantsPayload, undefined>({
    query: () => {
      return {
        path: `${TEST_MERCHANT_API_URL}`,
      };
    },
    providesTags: [DeveloperApiTagTypes.TestMerchant],
  }),

  /**
   * Delete a test merchant.
   */
  deleteTestMerchant: builder.mutation<void, string>({
    query: (testMerchantToken) => {
      return {
        path: `${TEST_MERCHANT_API_URL}/${testMerchantToken}`,
        method: HTTP_METHOD.DELETE,
      };
    },
    invalidatesTags: [DeveloperApiTagTypes.TestMerchant],
  }),
});

const testMerchantsEndpoints = testMerchantsEndpointsFactory(endpointBuilder);

export { testMerchantsEndpoints, testMerchantsEndpointsFactory };
